<template>
  <gs-button
    class="gs-copy-button"
    :variant="variant"
    :size="size"
    :disabled="disabled || !hasSomethingToCopy"
    :title="title || label"
    @click="copy()"
  >
    <gs-icon :name="icon" size="15" />
    {{ label }}
  </gs-button>
</template>

<script>
import { copyAsset } from './copyAsset';

export default {
  name: 'CopyButton',
  props: {
    // Plain-text flavour. Always copied, on its own or alongside `html`.
    text: {
      type: String,
      default: '',
    },
    // Optional rich flavour for assets that are meant to be pasted formatted
    // (email swipes, blog posts).
    html: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Copy',
    },
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'copy',
    },
    // The hero's "Copy link" is the one pink primary on this surface, so every
    // asset action stays outline by default.
    variant: {
      type: String,
      default: 'outline',
    },
    size: {
      type: String,
      default: 'sm',
    },
    disabled: Boolean,
  },
  computed: {
    hasSomethingToCopy() {
      return Boolean(this.text || this.html);
    },
  },
  methods: {
    async copy() {
      try {
        await copyAsset({ text: this.text, html: this.html }, value => this.$copyText(value));
        this.$emit('copied');
        this.$gsToast.success('Copied');
      } catch (error) {
        this.$emit('error');
        this.$gsToast.error('Could not copy');
      }
    },
  },
};
</script>
